<odl-toaster>
  @for (toast of toasts(); track toast.id) {
    <odl-toast
      [attr.variant]="toast.status"
      [attr.id]="toast.id"
      (odl-dismiss-click)="onDismiss(toast.id)"
    >
      {{ toast.message }}
    </odl-toast>
  }
</odl-toaster>
